import React, { useMemo } from "react";
import AreaChart from "../Charts/AreaChart";
import { MrrArrProps } from "../Charts/ChartConfig";
import { GEOGRAPHIC } from "../../Constant/constant";
import GeographicalCharts from "../Charts/GeographicalCharts";

const TableauGraphs = ({
  graphLabel,
  graphData,
  activeTab,
  activeGraphType,
  tooltipFormatter,
  showFirstChar,
  customToolTip,
  heatMap,
  tablueFilter,
}) => {
  const renderGraph = useMemo(() => {
    let data;
    if (graphData && typeof graphData[0] !== "object") {
      data = [{ name: "", data: graphData || [] }];
    } else {
      const dataMap = {};
      graphData?.forEach((item) => {
        Object.entries(item)?.forEach(([key, val]) => {
          if (!dataMap[key]) dataMap[key] = [];
          dataMap[key]?.push(val);
        });
      });
      data = Object.entries(dataMap)?.map(([key, values]) => ({
        name: key?.toUpperCase() || "",
        data: values,
      }));
    }
    return {
      ...MrrArrProps,
      ...tooltipFormatter,
      chartType: activeGraphType,
      categories: graphLabel || [],
      data: data?.length ? data : [{ name: "", data: [0] }],
    };
  }, [graphLabel, graphData]);

  return (
    <div className="chart-parent">
      <div className="chat-infos">
        <h6>{activeTab}</h6>
      </div>
      {activeTab === GEOGRAPHIC ? (
        <GeographicalCharts heatMap={heatMap} tablueFilter={tablueFilter} />
      ) : (
        <AreaChart
          showNameLabel={true}
          showFirstChar={showFirstChar}
          customToolTip={customToolTip}
          {...renderGraph}
          width="100%"
        />
      )}
    </div>
  );
};

export default TableauGraphs;
